/* Generated by restful-react */

import React from 'react'
import { Mutate, MutateProps, useMutate, UseMutateProps } from 'restful-react'

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>

/**
 * Error capturado cuando no se completa una petición.
 */
export interface ApiError {
  /**
   * Codigo del error
   */
  error_code: number
  /**
   * Mensaje del error
   */
  message_error: string
}

/**
 * Objeto que contiene la información que un usuario utiliza para acceder a la sala de chat.
 */
export interface TokenRequestBody {
  /**
   * Token en formato JWT
   */
  token?: string
}

/**
 * Token y documentos firmados por el paciente
 */
export interface TokenAndSignedDocuments {
  /**
   * Token de acceso
   */
  token: string
  /**
   * Documentos firmados por el paciente
   */
  signed_documents: DocumentType[]
  /**
   * Nombre del paciente
   */
  name: string
  /**
   * Número del documento de identificación
   */
  document_number: string
}

/**
 * Tipo de documento
 */
export type DocumentType = 'TermsAndConditions' | 'InformedConsent' | 'Other'

/**
 * Documento almacenado en al storage (blod y tabla)
 */
export interface Document {
  Type: DocumentType
  /**
   * Ruta del archivo
   */
  Path: string
}

export type PostTokenIntrospectionProps = Omit<MutateProps<void, ApiError, void, TokenRequestBody>, 'path' | 'verb'>

/**
 * Validar Token antes de acceder a sala de Chat
 *
 * Servicio Web que Recibe un token y valida lo siguiente:
 * 1) Si el token esta presente como parámetro en el query string.
 * 2) Si el token recibido es válido.
 * 3) Si la fecha de acceso al chat es demasiado temprano.
 * 4) Si la fecha de acceso al chat ya ha transcurrido y ya no esta disponible.
 */
export const PostTokenIntrospection = (props: PostTokenIntrospectionProps) => (
  <Mutate<void, ApiError, void, TokenRequestBody> verb='POST' path={`/api/v1/token/introspection`} {...props} />
)

export type UsePostTokenIntrospectionProps = Omit<UseMutateProps<void, void, TokenRequestBody>, 'path' | 'verb'>

/**
 * Validar Token antes de acceder a sala de Chat
 *
 * Servicio Web que Recibe un token y valida lo siguiente:
 * 1) Si el token esta presente como parámetro en el query string.
 * 2) Si el token recibido es válido.
 * 3) Si la fecha de acceso al chat es demasiado temprano.
 * 4) Si la fecha de acceso al chat ya ha transcurrido y ya no esta disponible.
 */
export const usePostTokenIntrospection = (props: UsePostTokenIntrospectionProps) =>
  useMutate<void, ApiError, void, TokenRequestBody>('POST', `/api/v1/token/introspection`, props)

export type PostAppointmentsDocumentsConsentsProps = Omit<
  MutateProps<void, ApiError, void, TokenAndSignedDocuments>,
  'path' | 'verb'
> & { appointment_id: string }

/**
 * Agregar o reemplazar consentimientos firmados por el paciente.
 *
 * Crea o reemplaza los documentos firmados por el paciente al ingresar a la teleconsulta. Antes de guardar estos documentos serán firmados para validar que no puedan ser manipulados posteriormente.
 */
export const PostAppointmentsDocumentsConsents = ({
  appointment_id,
  ...props
}: PostAppointmentsDocumentsConsentsProps) => (
  <Mutate<void, ApiError, void, TokenAndSignedDocuments>
    verb='POST'
    path={`/api/v1/appointments/${appointment_id}/documents/consents`}
    {...props}
  />
)

export type UsePostAppointmentsDocumentsConsentsProps = Omit<
  UseMutateProps<void, void, TokenAndSignedDocuments>,
  'path' | 'verb'
> & { appointment_id: string }

/**
 * Agregar o reemplazar consentimientos firmados por el paciente.
 *
 * Crea o reemplaza los documentos firmados por el paciente al ingresar a la teleconsulta. Antes de guardar estos documentos serán firmados para validar que no puedan ser manipulados posteriormente.
 */
export const usePostAppointmentsDocumentsConsents = ({
  appointment_id,
  ...props
}: UsePostAppointmentsDocumentsConsentsProps) =>
  useMutate<void, ApiError, void, TokenAndSignedDocuments>(
    'POST',
    `/api/v1/appointments/${appointment_id}/documents/consents`,
    props
  )
